// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data[data-v-050daf2f] {\n  height: 300px;\n  width: 100%;\n  text-align: center;\n  padding: 30px;\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
